module.exports = function anonymous(it
) {
var out='<p rel="localize[title]">Import progress for the file:<p/><p style=\'text-decoration: underline\'>'+(it.fileName)+'</p>';return out;
}